<template>
  <a-list
    class="list c-list"
    :loading="loading"
    itemLayout="horizontal"
    :pagination="pagination"
    :dataSource="results"
  >
    <list-cols-header
      slot="header"
      :headers="headers"
      :actions-cols="1"
      :col-spans="[24]"
      @sort="handleSort"
    />

    <a-list-item slot="renderItem" slot-scope="item">
      <a slot="actions">
        <a-button
          type="link"
          icon="message"
          @click="() => openDirectChat(item.id)"
        />
      </a>
      <a slot="actions">
        <router-link :to="`/admin/kursanci/szczegoly/${item.id}/kalendarz/`">
          <a-button type="link" icon="calendar" />
        </router-link>
      </a>
      <a slot="actions">
        <a-dropdown :trigger="['click']">
          <a-button type="link" icon="more" class="ant-dropdown-link" />
          <a-menu slot="overlay">
            <a-menu-item>
              <router-link :to="`/admin/kursanci/szczegoly/${item.id}/edytuj/`">
                edytuj profil kursanta
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a>
      <a-list-item-meta :description="item.courses.join(' | ')">
        <a slot="title">
          <router-link :to="`/admin/kursanci/szczegoly/${item.id}/edytuj/`">
            {{ item.full_name }}
          </router-link>
        </a>
        <a-avatar slot="avatar" icon="user" :src="item.avatar" />
      </a-list-item-meta>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  queryModels: ['ordering'],
  props: {
    results: Array,
    pagination: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        {
          title: 'Imię i nazwisko kursanta',
          sort: true,
          key: 'first_name'
        }
      ]
    }
  },
  methods: {
    handleSort(order) {
      this.ordering = order || undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin-top: 40px;
}
</style>
